import {
  parseEmitErrorResponse,
  parseEmitSuccessResponse,
  parseErrorResponse,
  parseSuccessResponse
} from "./parseResponse";


export interface IInterceptor {
  beforeRequest: () => Promise<void>;
  afterResponse: (response: any) => Promise<void>;
  afterError: (error: any) => Promise<void>;
}

export class Interceptor implements IInterceptor {
  async beforeRequest(): Promise<void> {}

  async afterResponse(response: any): Promise<void> {
    await parseSuccessResponse(response);
  }

  async afterError(error: any): Promise<void> {
    await parseErrorResponse(error);
  }
}

export class EventBusInterceptor implements IInterceptor {
  private readonly emit: any;

  constructor(emit: any) {
    this.emit = emit;
  }

  async beforeRequest(): Promise<void> {
    this.emit("loading", true);
  }

  async afterResponse(response: any): Promise<void> {
    await parseEmitSuccessResponse(response, this.emit);
    this.emit("loading", false);
  }

  async afterError(response: any): Promise<void> {
    this.emit("loading", false);
    await parseEmitErrorResponse(response, this.emit);
    this.emit("afterError", response);
  }
}
